<template>
    <div class="card">
        <div class="table-header mb-3">
            <div class="info_left">
                <h5 class="p-m-0">
                    Товари ({{ total }})
                </h5>

                <div class="action_panel">
                    <a href="javascript:void(0);" @click="getExcel()">
                        <Button icon="pi pi-external-link" label="Скачать XLS" />
                    </a>
                    <p><Checkbox v-model="filterParams.showDocumentsAnalytics" :binary="true" v-on:change="getData()" /> Додати аналітику по документам</p>
                </div>
            </div>

            <div class="analytics">
                <span class="text-danger" v-if="productsInInactiveCategories"><b>{{ productsInInactiveCategories }}</b> активних товарів без категорії</span>
            </div>
        </div>
        <DataTable
            :value="data"
            v-model:selection="selectedCharacteristics"
            v-model:filters="filterParams.filters"
            filterDisplay="row"
            paginator
            lazy
            :rows="filterParams.perPage"
            :rowsPerPageOptions="[50, 100, 200]"
            :total-records="total"
            :loading="loading"
            @page="onPage($event)"
            @filter="getData()"
            class="customTable scroll_h"
            @sort="onSort($event)"
            @row-select-all="onSelectAllChange"
            @row-select="onRowSelect"
            @row-unselect="onRowUnselect"
        >
            <Column selectionMode="multiple" :class="{'select-all-selected': selectAll}" headerStyle="width: 3rem"></Column>
            <Column field="id" :sortable="true" header="ID в системі">
                <template #body="slotProps">
                    {{ slotProps.data.id }}
                </template>
            </Column>
            <Column field="remote_id" :sortable="true" header="ID" headerStyle="min-width: 150px;">
                <template #body="slotProps">
                    {{ slotProps.data.remote_id }}
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.remote_id.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="article" :sortable="true" header="Артикул" headerStyle="min-width: 200px;">
                <template #body="slotProps">
                    {{ slotProps.data.article }}
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.article.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="brand" :sortable="true" header="Бренд" headerStyle="min-width: 200px;">
                <template #body="slotProps">
                    {{ slotProps.data.brand ? slotProps.data.brand.title : null }}
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.brand.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="is_active_category" :sortable="true" header="Наявність категорії" headerStyle="max-width: 100px;">
                <template #body="slotProps">
                    {{ slotProps.data.is_active_category ? 'Так' : 'Ні' }}
                </template>
                <template #filter>
                    <Dropdown style="width: 70px;" v-model="filterParams.filters.is_active_category.value" :options="isActiveCategory" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="is_b2c" :sortable="true" header="Для В2С" headerStyle="max-width: 100px;">
                <template #body="slotProps">
                    {{ slotProps.data.is_b2c ? 'Так' : 'Ні' }}
                </template>
                <template #filter>
                    <Dropdown style="width: 70px;" v-model="filterParams.filters.is_b2c.value" :options="isB2C" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="is_promo" :sortable="true" header="Акція" headerStyle="max-width: 100px;">
                <template #body="slotProps">
                    {{ slotProps.data.is_promo ? 'Так' : 'Ні' }}
                </template>
                <template #filter>
                    <Dropdown style="width: 70px;" v-model="filterParams.filters.is_promo.value" :options="isPromo" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="is_new" :sortable="true" header="Новинка" headerStyle="max-width: 100px;">
                <template #body="slotProps">
                    {{ slotProps.data.is_new ? 'Так' : 'Ні' }}
                </template>
                <template #filter>
                    <Dropdown style="width: 70px;" v-model="filterParams.filters.is_new.value" :options="isPromo" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="is_hit" :sortable="true" header="Хіт" headerStyle="max-width: 100px;">
                <template #body="slotProps">
                    {{ slotProps.data.is_hit ? 'Так' : 'Ні' }}
                </template>
                <template #filter>
                    <Dropdown style="width: 70px;" v-model="filterParams.filters.is_hit.value" :options="isPromo" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="type_id" :sortable="true" header="Категорія товару" headerStyle="max-width: 100px;">
                <template #body="slotProps">
                    {{ slotProps.data.type ? slotProps.data.type.name : '' }}
                </template>
                <template #filter>
                    <Dropdown style="width: 70px;" v-model="filterParams.filters.type.value" :options="productTypes" filter @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="name" :sortable="true" header="Найменування" headerStyle="min-width: 700px;">
                <template #body="slotProps">
                    {{ slotProps.data.name }}
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.name.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="status" :sortable="true" header="Статус">
                <template #body="slotProps">
                    {{ slotProps.data.status === 'a' ? 'Активний' : 'Вимкнено' }}
                </template>
                <template #filter>
                    <Dropdown style="width: 90px;" v-model="filterParams.filters.status.value" :options="statuses" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="created_at" :sortable="true" header="Дата створення">
                <template #body="slotProps">
                    {{ moment(slotProps.data.created_at).format("DD.MM.YYYY") }}
                </template>
            </Column>
            <Column field="disabled_date" header="Дата вимкнення" headerStyle="min-width: 200px;">
                <template #body="slotProps">
                    {{ slotProps.data.disabled_date ? moment(slotProps.data.disabled_date).format("DD.MM.YYYY HH:mm") : '' }}
                </template>
                <template #filter>
                    <Calendar v-model="filterParams.filters.disabled_date.value" selection-mode="range" dateFormat="mm/dd/yy" @update:modelValue="getData()" placeholder="Діапазон" />
                </template>
            </Column>
            <Column field="media_count" :sortable="true" header="Медіа">
                <template #body="slotProps">
                    {{ slotProps.data.media_count }}
                </template>
            </Column>
            <Column field="products_files_count" :sortable="true" header="Файли">
                <template #body="slotProps">
                    {{ slotProps.data.products_files_count }}
                </template>
            </Column>
            <Column field="characteristics_count" :sortable="true" header="Харак.">
                <template #body="slotProps">
                    {{ slotProps.data.characteristics_count }}
                </template>
            </Column>
            <Column field="accessories_count" :sortable="true" header="Аксес.">
                <template #body="slotProps">
                    {{ slotProps.data.accessories_count }}
                </template>
            </Column>
            <Column field="catalog_analogs_count" :sortable="true" header="Аналоги">
                <template #body="slotProps">
                    {{ slotProps.data.catalog_analogs_count }}
                </template>
            </Column>
            <Column field="catalog_buy_with_products_count" :sortable="true" header="З цим товаром купують" headerStyle="max-width: 100px;">
                <template #body="slotProps">
                    {{ slotProps.data.catalog_buy_with_products_count }}
                </template>
            </Column>

            <template v-for="fileType in fileTypes" :key="fileType.code">
                <Column :field="fileType.code + '_files_count'" :header="fileType.title">
                    <template #body="slotProps">
                        {{ slotProps.data[fileType.code + '_files_count'] }}
                    </template>
                </Column>
            </template>

            <Column field="" header="">
                <template #body="slotProps">
                    <div class="actions">
                        <a v-if="slotProps.data.status === 'd' && $page.props.user.role === 'admin'" href="#" @click.prevent="() => {targerCombineProduct = slotProps.data; copyProductDataModal=!copyProductDataModal}">

                            <svg height="20px" width="20px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                viewBox="0 0 210.107 210.107" xml:space="preserve">
                            <g>
                                <path style="fill:#356EEF;" d="M168.506,0H80.235C67.413,0,56.981,10.432,56.981,23.254v2.854h-15.38
                                    c-12.822,0-23.254,10.432-23.254,23.254v137.492c0,12.822,10.432,23.254,23.254,23.254h88.271
                                    c12.822,0,23.253-10.432,23.253-23.254V184h15.38c12.822,0,23.254-10.432,23.254-23.254V23.254C191.76,10.432,181.328,0,168.506,0z
                                    M138.126,186.854c0,4.551-3.703,8.254-8.253,8.254H41.601c-4.551,0-8.254-3.703-8.254-8.254V49.361
                                    c0-4.551,3.703-8.254,8.254-8.254h88.271c4.551,0,8.253,3.703,8.253,8.254V186.854z M176.76,160.746
                                    c0,4.551-3.703,8.254-8.254,8.254h-15.38V49.361c0-12.822-10.432-23.254-23.253-23.254H71.981v-2.854
                                    c0-4.551,3.703-8.254,8.254-8.254h88.271c4.551,0,8.254,3.703,8.254,8.254V160.746z"/>
                            </g>
                            </svg>
                        </a>
                        <a v-if="$page.props.user.role === 'admin'" href="#" @click.prevent="() => {selectedCharacteristics=[]; selectedCharacteristics.push(slotProps.data); deleteCharacteristics()}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clip-path="url(#clip0_7077_121330)">
                                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#B70D09"></path>
                                </g>
                                <defs><clipPath id="clip0_7077_121330"><rect width="24" height="24" fill="white"></rect></clipPath></defs>
                            </svg>
                        </a>
                    </div>
                </template>
            </Column>
        </DataTable>

        <div class="bottom_btns" v-if="$page.props.user.role === 'admin'">
            <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedCharacteristics.length" @click="deleteCharacteristics()">Видалити</a>
            <a href="javascript:void(0)" class="add_file_btn main disabled" v-else>Видалити</a>
        </div>

        <Dialog v-model:visible="copyProductDataModal" id="characteristics-table-3" header="Об’єднати товари" :style="{ 'width': '500px' }" modal :contentStyle="{ height: '400px' }">
            <div class="modal_main_content">
                <span>Об'єднати товар {{ targerCombineProduct.article }} з товаром: </span>
                <InputText v-model="searchProductQuery" @input="searchProduct()" :placeholder="'Пошук за артикулом'" />
            </div>
            <template v-if="searchResult.length">
                <div class="searched_result" v-for="searchResultItem in searchResult" :key="searchResultItem.id">
                    <span>Артикул: <b>{{ searchResultItem.article }}</b></span>
                    <span>Назва: <b>{{ searchResultItem.name }}</b></span>
                    <span>Бренд: <b>{{ searchResultItem.brand ? searchResultItem.brand.title : '' }}</b></span>
                </div>
            </template>
            <div v-else class="searched_result">
                <span><b>Товарів не знайдено</b></span>
            </div>

            <div class="nested_list">
                <span>Оберіть елементи для об'єднання: </span>
                <label>
                    <input type="checkbox" :value="'medias'" v-model="selectedMatchingEntities">
                    <p>Медіа</p>
                </label>
                <label>
                    <input type="checkbox" :value="'files'" v-model="selectedMatchingEntities">
                    <p>Файли</p>
                </label>
                <label>
                    <input type="checkbox" :value="'characteristics'" v-model="selectedMatchingEntities">
                    <p>Характеристики</p>
                </label>
                <label>
                    <input type="checkbox" :value="'accessories'" v-model="selectedMatchingEntities">
                    <p>Аксесуари</p>
                </label>
                <label>
                    <input type="checkbox" :value="'buy_with_products'" v-model="selectedMatchingEntities">
                    <p>З цим товаром купують</p>
                </label>
            </div>
            <template #footer>
                <div class="confirm_buttons">
                    <a v-if="searchResult.length" href="#" class="confirm_button_cancel" @click.prevent="combineProducts()">Об’єднати</a>
                    <a v-else href="#" class="confirm_button_cancel disabled" disabled>Об’єднати</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="copyProductDataModal=false">Відмінити</a>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "@/Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import {FilterMatchMode} from "primevue/api";
import moment from "moment";
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';

export default {
    props: {
        productsInInactiveCategories: {
            type: Number,
            default: 0,
            required: false,
        }
    },
    components: {
        DataTable,
        Column,
        InputText,
        swal,
        Dialog,
        Button,
        Dropdown,
        Toast,
        Calendar,
        Checkbox,
    },
    layout: AppLayout,

    data() {
        return {
            moment: moment,
            data: [],
            fileTypes: [],
            productTypes: [],
            total: 0,
            targerCombineProduct: null,
            copyProductDataModal: false,
            searchProductQuery: null,
            selectedCharacteristics: [],
            filterParams: {
                page: 1,
                perPage: 50,
                order_by: null,
                order: 1,
                showDocumentsAnalytics: false,
                filters: {
                    article: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    remote_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    is_active_category: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    is_b2c: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    is_promo: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    is_new: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    is_hit: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    type: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    brand: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    disabled_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
                }
            },
            newCharacteristic: {
                article: null,
                remote_id: null,
                name: null,
                status: null,
                brand: null,
            },
            loading: false,
            selectAll: false,
            isAddCharacteristics: false,
            statuses: [
                {
                    value: 'a',
                    name: 'Активний'
                },
                {
                    value: 'd',
                    name: 'Вимкнено'
                },
            ],
            isActiveCategory: [
                {
                    value: 'a',
                    name: 'Так'
                },
                {
                    value: 'd',
                    name: 'Ні'
                },
            ],
            isB2C: [
                {
                    value: 'a',
                    name: 'Так'
                },
                {
                    value: 'd',
                    name: 'Ні'
                },
            ],
            isPromo: [
                {
                    value: 'a',
                    name: 'Так'
                },
                {
                    value: 'd',
                    name: 'Ні'
                },
            ],
            selectedMatchingEntities: [
                'medias',
                'files',
                'characteristics',
                'accessories',
                'buy_with_products'
            ],
            searchResult: [],
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        onSort(event) {
            this.filterParams.order_by = event.sortField
            this.filterParams.order = event.sortOrder
            
            this.getData()
        },
        getData() {
            this.loading = true
            axios.post(this.route('api.catalog.product.products.get'), this.filterParams).then(result => {
                this.data = result.data.products.data;
                this.fileTypes = result.data.fileTypes;
                this.productTypes = result.data.productTypes;
                this.total = result.data.products.total;
                this.loading = false
            });
        },
        searchProduct() {
            let filterParams = {
                page: 1,
                perPage: 1,
                order_by: null,
                order: 1,
                filters: {
                    article: { value: this.searchProductQuery, matchMode: FilterMatchMode.CONTAINS },
                    status: { value: 'a', matchMode: FilterMatchMode.CONTAINS },
                }
            }

            if (this.searchProductQuery) {
                axios.post(this.route('api.catalog.product.products.get'), filterParams).then(result => {
                    this.searchResult = result.data.products.data;
                });
            }
        },
        combineProducts() {
            this.copyProductDataModal=false
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані товари будуть об\'єднані',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.copyProductDataModal=true
                    return
                }

                let productId = null
                this.searchResult.forEach((value, index) => {
                    productId = value.remote_id
                });

                axios.post(this.route('api.catalog.product.combine'), {target: this.targerCombineProduct.remote_id, product: productId, entities: this.selectedMatchingEntities})
                    .then((result) => {
                        this.getData()
                        this.selectedCharacteristics = []
                        this.$toast.add({ severity: 'success', summary: 'Успішно об\'єднано!', detail: '', life: 3000 });
                    }).catch((error) => {
                        this.selectedCharacteristics = []
                        alert(error);
                        window.scroll(0, 0);
                    })

            });
        },
        deleteCharacteristics() {
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані товари будуть видалені',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.selectedCharacteristics = []
                    return
                }

                axios.post(this.route('api.catalog.product.products.library.delete'), {data: this.selectedCharacteristics})
                    .then((result) => {
                        this.getData()
                        this.selectedCharacteristics = []
                        this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Товари успішно видалено', life: 3000 });
                    }).catch((error) => {
                        this.selectedCharacteristics = []
                        alert(error);
                        window.scroll(0, 0);
                    })

            });
        },
        onPage(event) {
            this.filterParams.page = event.page+1
            this.filterParams.perPage = event.rows
            this.getData()
        },
        onSelectAllChange() {
            if (this.data.length >= this.filterParams.perPage) {
                if (!this.selectAll) {
                    this.selectAll = true;
                    this.selectedCharacteristics = this.data
                } else {
                    this.selectAll = false;
                    this.selectedCharacteristics = [];
                }
            }
        },
        onRowSelect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = this.selectedCharacteristics.length === this.data.length
            }
        },
        onRowUnselect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = false;
            }
        },
        getExcel() {
            axios.post(this.route('api.catalog.product.products.get_excel'), this.filterParams,
                {
                    responseType: 'blob'
                }
            )
            .then(function (result) {
                let blob = new Blob([result.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'products-'+Date.now()+'.xlsx');
                document.body.appendChild(link);
                link.click();
            })
        }
    }
};
</script>

<style scoped>
.analytics {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.action_panel {
    display: flex;
    gap: 15px;
}
.text-danger {
    color: red;
}
.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled, .confirm_button_cancel.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.price_input {
    height: 40px!important;
    width: 100%;
    align-items: center;
    display: flex;
}
.check-text input {
  display: none;
}
.check-text svg {
  cursor: pointer;
}
.modal_main_content_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.p-inputtext {
    height: auto;
}
.p-dropdown-label .p-inputtext{
    align-items: center;
    display: flex;
}

.scroll_h {
    overflow: auto;
}

.actions {
    display: flex;
    align-items: center;
    gap: 7px;
}

.modal_group_item label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
}

input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.nested_list {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.nested_list label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
}

.modal_main_content {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.searched_result {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 7px;
}
</style>
